export default "__VITE_ASSET__B4zpJ91M__"